/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { createAction } from 'redux-actions';
import { createTypesMap } from './types';

export const types = createTypesMap('sidebar', [
  'toggleSidebar',
]);

function toggleSidebar() {
  return createAction(types.toggleSidebar)();
}


export default {
  toggleSidebar,
};




// WEBPACK FOOTER //
// ./src/redux/actions/sidebar.js